import { render, staticRenderFns } from "./FieldLearnPage.vue?vue&type=template&id=3faf083a"
import script from "./FieldLearnPage.vue?vue&type=script&lang=js"
export * from "./FieldLearnPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports